import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Cpu, Clock, CheckCircle2, AlertTriangle } from "lucide-react";

export const NOCStatsCards = ({ stats }) => {
  if (!stats) return null;

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4" data-testid="noc-stats-cards">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Total Operations</CardTitle>
          <Cpu className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.total_operations}</div>
          <p className="text-xs text-muted-foreground">All time logged operations</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Avg Response Time</CardTitle>
          <Clock className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.average_execution_time_ms}ms</div>
          <p className="text-xs text-muted-foreground">Average execution time</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Success Rate</CardTitle>
          <CheckCircle2 className="h-4 w-4 text-emerald-500" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-emerald-500">
            {stats.by_status.find(s => s.status === "SUCCESS")?.count || 0}
          </div>
          <p className="text-xs text-muted-foreground">Successful operations</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Errors</CardTitle>
          <AlertTriangle className="h-4 w-4 text-red-500" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-red-500">
            {(stats.by_status.find(s => s.status === "FAILURE")?.count || 0) +
             (stats.by_status.find(s => s.status === "ERROR")?.count || 0)}
          </div>
          <p className="text-xs text-muted-foreground">Failed operations</p>
        </CardContent>
      </Card>
    </div>
  );
};
